import { ArrowUturnRightIcon, XMarkIcon } from '@heroicons/react/16/solid';
import { Timeout } from 'ahooks/lib/useRequest/src/types';
import { useEffect, useState } from 'react';
import { Avatar, Button, Checkbox, Divider, Input, Modal } from 'react-daisyui';
import { randomString } from '../../../../../../../../../../functions/string.functions.ts';
import { useModalsContext } from '../../../../../../../../../../providers/ModalsProvider/Modals.context.ts';
import { useWorkspaceContext } from '../../../../../../../../../../providers/WorkspaceProvider/Workspace.context.ts';
import { useChatContext } from '../../../../../../../../Chat.hook.ts';
import { tGetLeadsDataResponse } from '../../../../../../../../Chat.types.ts';
import useReSendMessageModal from './ReSendMessageModal.hook.ts';
import './ReSendMessageModal.styles.scss';
import { eChannelType } from 'src/providers/SocketsProvider/Sockets.enums.ts';
import { ChatState } from 'src/components/Chat/Chat.enum.ts';
import { useTranslation } from 'react-i18next';

export function ReSendMessageModal() {
  const { t } = useTranslation('chat/chat');
  const { currentWorkspaceId } = useWorkspaceContext();
  const { showResendModal, setShowResendModal } = useModalsContext();
  const { setResendIds, setSelectedChatsIds, selectedChatsIds, selectedChat } =
    useChatContext();
  const {
    leads,
    setLeads,
    onReSendMessages,
    loadingPetition,
    getForwardLeads,
  } = useReSendMessageModal();
  const [filteredLeads, setFilteredLeads] = useState<tGetLeadsDataResponse[]>(
    [],
  );
  let timer: Timeout | null = null;

  useEffect(() => {
    setFilteredLeads(leads);
  }, [leads]);

  function onCloseModal() {
    setShowResendModal(false);
    setResendIds([]);
    setFilteredLeads([]);
    setSelectedChatsIds([]);
    setLeads([]);
  }

  async function onSelectChat(lead: tGetLeadsDataResponse) {
    if (!currentWorkspaceId) return;

    let ids: string[] = [];
    if (lead.chatID) {
      const isSelected = selectedChatsIds.includes(lead.chatID);

      if (isSelected) {
        ids = selectedChatsIds.filter((chatId) => chatId !== lead.chatID);
      } else {
        ids = [...selectedChatsIds, lead.chatID ?? ''];
      }
    }

    ids = ids.filter((id) => id !== undefined);
    ids = Array.from(new Set(ids));

    setSelectedChatsIds(ids);
  }

  function onSearchLeads(event: React.ChangeEvent<HTMLInputElement>) {
    const { value } = event.target;
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      getForwardLeads(value);
    }, 400);
  }

  return (
    <Modal
      open={showResendModal}
      style={{ zIndex: 9999 }}
      backdrop={false}
      responsive={true}
    >
      <div className="ReSendMessageModal">
        <div className="ReSendMessageModal__Header">
          <h1 className="ReSendMessageModal__Title">
            {t('messageMenu.sendToAnotherChatTitle')}
          </h1>

          <Button color="ghost" onClick={onCloseModal} size="sm">
            <XMarkIcon className="w-7 h-7" />
          </Button>
        </div>

        <Divider />

        <Input
          onChange={onSearchLeads}
          placeholder={t('messageMenu.sendToAnotherChatSearch')}
        />

        <Divider />

        {filteredLeads.length > 0 && (
          <h2 className="ReSendMessageModal__Subtitle">
            {t('messageMenu.sendToAnotherChatRecent')}
          </h2>
        )}

        <div className="ReSendMessageModal__Content__Leads">
          {filteredLeads &&
            filteredLeads.map((lead) => {
              const isSelected = selectedChatsIds.includes(lead.chatID ?? '');

              return (
                <div className="ReSendMessageModal__Lead" key={randomString()}>
                  <div className="ReSendMessageModal__Lead__Left">
                    <Checkbox
                      onClick={() => onSelectChat(lead)}
                      defaultChecked={isSelected}
                      disabled={
                        (lead?.chat?.integration ===
                          eChannelType.WHATSAPP_API &&
                          lead?.chat?.state === ChatState.INACTIVE) ||
                        !lead.chatID ||
                        selectedChat?.integration !== lead?.chat?.integration
                      }
                    />

                    <Avatar
                      shape="circle"
                      letters={lead.name.substring(0, 2)}
                      color="primary"
                      size="xs"
                      src={lead.profilePicture ?? ''}
                    />
                    {lead.name}
                  </div>
                  <div className="ReSendMessageModal__Lead__Left__Bubble">
                    {lead.status}
                  </div>
                </div>
              );
            })}

          {!filteredLeads.length && (
            <p className="min-w-full text-xl text-center p-8">
              No se encontraron resultados
            </p>
          )}
        </div>
        <div className="ReSendMessageModal__Button">
          <Button
            loading={loadingPetition}
            color="primary"
            onClick={onReSendMessages}
            disabled={!selectedChatsIds.length}
          >
            {t('messageMenu.sendToAnotherChatConfirm')}
            <ArrowUturnRightIcon className="w-3 h-3" />
          </Button>
        </div>
      </div>
    </Modal>
  );
}
